import ProductCodes from './productCodeConverter';

export const productCodes = {
    ProductCodes
};